import React, { useEffect, useRef, useState } from 'react'
import className from 'classnames/bind'

import style from './MyhousePriceSource.module.scss'

import IconTooltip from '@Ui/images/myhouse/IconTooltip.svg'
import IconClose15x15 from '@Ui/images/myhouse/IconClose15x15.svg'
import { PRICE_PROVIDER, PROVIDER, TRADE } from '@Root/contants'
import { handleNclick } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  provider: PROVIDER
  price?: any
  tradeTypeCurrentTab?: any
}

const MyhousePriceSource: React.FC<Props> = ({ provider, price, tradeTypeCurrentTab }: Props) => {
  //변수선언부
  const [isOpen, setIsOpen] = useState(false)
  const [priceProvider, setPriceProvider] = useState(PRICE_PROVIDER[provider])
  const tooltipLayer = useRef(null)
  const tooltipButton = useRef(null)
  const prices = price?.table.marketPrices
  const [exposeInfo, setExposeInfo] = useState(false)

  //함수정의부
  const handleTooltipToggle = (evt: React.SyntheticEvent) => {
    handleNclick(NCLICK.MY_HOUSE.REAL_PRICE.TOOLTIP, evt)
    //REAL_PRICE.TOOLTIP
    if (isOpen) {
      handleTooltipClose()
    } else {
      setIsOpen(true)
      document.addEventListener('mousedown', handleClickOutside)
    }
  }

  const handleTooltipClose = () => {
    setIsOpen(false)
    document.removeEventListener('mousedown', handleClickOutside)
  }

  const handleClickOutside = (event: any) => {
    let ele = event.target
    while (true) {
      if (ele === tooltipLayer.current || ele === tooltipButton.current) {
        break
      } else if (ele.id === 'wrap' || ele.nodeName.toUpperCase() === 'BODY') {
        handleTooltipClose()
        break
      }
      ele = ele.parentNode
    }
  }

  //useEffect
  useEffect(() => {
    const priceProvider = PRICE_PROVIDER[provider]
    setPriceProvider(priceProvider)
  }, [provider])

  useEffect(() => {
    if (prices) {
      setExposeInfo(Object.keys(prices).length !== 0)
    }
  }, [prices])

  return (
    <>
      {!!provider && exposeInfo ? (
        <div className={cx('myhouse_price_source')}>
          <button type="button" className={cx('myhouse_button_tooltip')} onClick={handleTooltipToggle}>
            <IconTooltip />
            <span className="blind">시세 기준 보기</span>
          </button>
          {isOpen && (
            <div className={cx('myhouse_source_tooltip')}>
              <strong className={cx('myhouse_tooltip_title')}>시세 기준</strong>
              {priceProvider.CODE === 'kab' && (
                <p className={cx('myhouse_source_text')}>
                  본 시세는 실거래 가격, 방매 사례 및 시세 도움 중개업소 의견가격 등을 종합 참작하여
                  <em className={cx('myhouse_text_emphasize')}> {priceProvider.LABEL}에서 제공하는 시세 범위</em>
                  이며, 개별적인 감정평가액이나 특정 실거래가격 및 민간 업체 시세와는 다소 차이가 날 수 있습니다.
                </p>
              )}
              {priceProvider.CODE === PROVIDER.KBSTAR && (
                <p className={cx('myhouse_source_text')}>
                  본 시세는 <em className={cx('myhouse_text_emphasize')}>{priceProvider.LABEL}</em>에서 제공하는 것으로, 다른 부동산정보업체가 제시한 시세, 감정평가액 및
                  실거래가격과는 다소 차이가 날 수 있습니다.
                </p>
              )}
              {priceProvider.CODE === PROVIDER.NEONET && (
                <p className={cx('myhouse_source_text')}>
                  본 시세는
                  <em className={cx('myhouse_text_emphasize')}> {priceProvider.LABEL}</em>
                  에서 제공하는 것으로, 다른 부동산정보업체가 제시한 시세, 감정평가액 및 실거래가격과는 다소 차이가 날 수 있습니다.
                </p>
              )}
              <button type="button" className={cx('myhouse_button_close')} onClick={() => handleTooltipClose()}>
                <IconClose15x15 />
                <span className="blind">툴팁 닫기</span>
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className={cx('myhouse_price_source')}>
          <button type="button" className={cx('myhouse_button_tooltip')} onClick={handleTooltipToggle}>
            <IconTooltip />
            <span className="blind">시세 기준 보기</span>
          </button>
          {isOpen && (
            <div className={cx('myhouse_source_tooltip')}>
              <strong className={cx('myhouse_tooltip_title')}>시세 기준</strong>
              {tradeTypeCurrentTab === TRADE.RENT && (!exposeInfo || !prices) && (
                <p className={cx('myhouse_source_text')}>
                  시세는 <em className={cx('myhouse_text_emphasize')}> KB부동산</em>에서 제공받고 있으며, 시세 내역이 없는 경우도 발생할 수 있습니다.
                </p>
              )}
              {(tradeTypeCurrentTab === TRADE.DEAL || tradeTypeCurrentTab === TRADE.LEASE) && (!exposeInfo || !prices) && (
                <p className={cx('myhouse_source_text')}>
                  시세는
                  <em className={cx('myhouse_text_emphasize')}> 한국감정원/KB부동산/부동산뱅크</em>
                  에서 제공받고 있으며, 시세 내역이 없는 경우도 발생할 수 있습니다.
                </p>
              )}
              <button type="button" className={cx('myhouse_button_close')} onClick={() => handleTooltipClose()}>
                <IconClose15x15 />
                <span className="blind">툴팁 닫기</span>
              </button>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default MyhousePriceSource
